import { render, staticRenderFns } from "./FlowShared.vue?vue&type=template&id=30edfbaa&"
import script from "./FlowShared.vue?vue&type=script&lang=js&"
export * from "./FlowShared.vue?vue&type=script&lang=js&"
import style0 from "./FlowShared.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports